import { useEffect } from "react";

const TcsPlugins = () => {

  useEffect(()=>{
    let current_page = window.location.href.split('/').at(-1)
    setTimeout(()=>{
        document.getElementById(`${current_page}`).scrollIntoView({  marginTop: '300px', behavior: 'smooth',  });
    }, 100)
})
window.addEventListener("scroll", function(event) {
    let top = this.scrollY,
        window_width = window.innerWidth,
        header_height = document.querySelector("header").style.height+100;
        // (top > header_height && window_width > 1024) ? document.querySelector("nav").classList.add('fixed-header-desktop') : document.querySelector("nav").classList.remove('fixed-header-desktop')
        (top > header_height && window_width > 1024) ? document.querySelector("a").classList.add('fixed-header-desktop') : document.querySelector("a").classList.remove('fixed-header-desktop')
}, false);  
window.addEventListener("scroll", function(event) {
    let top = this.scrollY,
        window_width = window.innerWidth,
        header_height = document.querySelector("header").style.height+100;
        (top > header_height && window_width > 1024) ? document.querySelector("nav").classList.add('fixed-header-desktop') : document.querySelector("nav").classList.remove('fixed-header-desktop')
        // (top > header_height && window_width > 1024) ? document.querySelector("a").classList.add('fixed-header-desktop') : document.querySelector("a").classList.remove('fixed-header-desktop')
}, false);  
  return (
    <div>
      <div  className="tcs-plugins-image">
        <img src='/new-image/tcs-plugins.jpg' alt='' className='w-[100%]'/>
      </div>

    
      <div className="flex flex-col max-w-[55rem] mx-auto p-[3rem]">
        <h1 className="text-[30px] font-bold mb-5">Shopify Plugin</h1>
        <div className="mb-4">
          TCS E-retail company provides courier services to Shopify store owners
          who are using TCS as their logistics provider. Shipping goods to
          customer’s door is universally known to be a hassle. TCS makes this
          process effortless for Shopify store owners, with its Shopify App
          [E-Connect by TCS] for Shopify store owners. The Shopify App makes the
          process time-efficient, reliable and effortless for Shopify store
          owners, who can now facilitate the delivery process online, through an
          automated system integrated with TCS E-retail portal.
        </div>
        <h1 className="text-[18px] font-bold mb-5">Features:</h1>
        <div className="mb-4">
          Shopify store owners who use the Shopify App ‘E-Connect by TCS’ can
          integrate their stores with TCS E-retail portal. This integration will
          help them achieve the following:
          <ol style={{ listStyle: "decimal" }} className="ml-5 ">
            <li>
              Send shipping details of online COD orders to TCS E-retail portal.
            </li>
            <li>
              Receive shipping label from TCS E-retail portal in HTML or PDF
              Format.
            </li>
            <li>Take prints of shipping labels.</li>
          </ol>
        </div>
        <h1 className="text-[18px] font-bold">How it works:</h1>
        <div className="mb-5">
          <ol style={{ listStyle: "decimal" }} className="ml-5 mt-4">
            <li className="pb-4">
              Install the app in order to integrate your store with TCS E-retail
              portal.
            </li>
            <li>
              Once the app is installed, please navigate to 'E-Connect by TCS'
              API configuration panel. You can configure the form with these
              details: Once the app is installed, please navigate to 'E-Connect
              by TCS' API configuration panel. You can configure the form with
              these details:
              <ul style={{ listStyle: "disc" }} className="mt-4 pb-4">
                <li className="pb-2">
                  Your API Key is your username and your API Password is your
                  password which you use while logging into COD Booking portal
                  www.tcscourier.com/cod/.
                </li>
                <li className="pb-2">
                  If you want to print booking consignment label as a PDF, you
                  can select PDF from "Print As" field above and if you want to
                  print label as HTML, please select HTML from the same field.
                </li>
                <li className="pb-2">
                  The Cost Centre Code and Label is also found on TCS COD Booking
                  Portal www.tcscourier.com/cod/ in Setup->cost centre details
                  by pressing the search button. CC Code will be entered in the
                  Cost Centre Code field and CC Name will be entered in the Cost
                  centre Label field respectively.
                </li>
                <li>
                  After entering all this information, please press save button
                  to save the configuration.
                </li>
              </ul>
            </li>
            <li className="mb-4">
              After doing the above configuration, please navigate to your
              store's Orders section and then from there, please select any
              order for which you want to book a shipment. On the admin order
              details page, please select "COD Shipping Booking" from the "More
              actions" dropdown.
            </li>
            <li className="mb-4">
              You will be taken to the TCS Shipment Booking form. Please fill
              the information on this form and then submit the form. After that
              the shipment booking will be done and you will get the Shipment
              Label in the HTML/PDF form. This is all you need to do to book
              shipments for your COD orders with TCS E-retail portal.
            </li>
          </ol>
          <div className="ml-5">
            <button className="btn-download ml-2 mt-2">
              <a href="https://spfyapp.tcscourier.com/">Download</a>
            </button>
          </div>
        </div>
        <h1 className="text-[30px] font-bold mb-5 mt-5">Magento Plugin</h1>
        <div className="mb-4">
          TCS Courier E-Connect COD automatically exports online customer’s
          orders to the TCS E-com Solutions E-retail Portal, with just one click.
        </div>
        <div className="mb-4">
          TCS E-com Solutions is a product catering to the needs of all
          aspirational E-retailers who want quick flow of goods to their
          customers. From simple shipment preparation to seamless last mile
          deliveries, TCS E-com Solutions offers a complete range of services
          including updated shipment tracking, timely email and sms alerts, easy
          transfer of funds and convenient return solutions to bolster and
          support your online business. TCS E-com Solutions provides unparalleled
          ease and convenience to its customers, with its value-added services
          namely “My Collect”, “My Return” and “My Drop”.
        </div>
        <div className="mb-4">
          Shipping goods is universally known to be a hassle. Our customized
          plugin “TCS Courier E-Connect COD” facilitates customers who are using
          services of TCS E-com Solutions and have their online stores on
          Magento. The plugin integrates our customer's websites with the
          E-retail portal and automates the transfer of their data, online
          orders and generation of labels, to the TCS E-retail portal. "TCS
          Courier E-Connect COD" automatically exports online customer’s orders
          to the TCS E-com Solutions E-retail Portal, with just one click.
        </div>

        <h1 className="text-[18px] font-bold mt-4 mb-3">Account & Pricing:</h1>
        <ol style={{ listStyle: "decimal" }} className="ml-5 mb-4">
          <li>A separate account is required for the plugin integration.</li>
          <li>The account is created before the extension installation.</li>
          <li>There are no additional fees for this service/account.</li>
        </ol>

        <h1 className="text-[18px] font-bold mb-4">
          Features of TCS Courier E-Connect COD:
        </h1>
        <ol style={{ listStyle: "decimal" }} className="ml-5 ">
          <li>
            Time-efficient, reliable and effortless online delivery process.
          </li>
          <li>
            Sends shipping details of online COD orders to TCS E-retail portal.
          </li>
          <li>
            Receive shipping label from TCS E-retail portal in HTML or PDF
            formats.
          </li>
          <li>Print Shipping Label.</li>
          <li>
            TCS Courier E-Connect COD plugin is free for all TCS customers.
          </li>
          <li>No hidden charges.</li>
          <li>Easy one-click installation process.</li>
        </ol>

        <div className="ml-0 mt-2">
          <button className="btn-download ml-2 mt-2">
            <a href="http://tcscouriers.com/TCSApp/Download/Tcs_Codshippingbooking-0.0.7.rar">
              Download
            </a>
          </button>
        </div>
      </div>
    </div>
  );
};

export default TcsPlugins;
